import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { DoctorsService } from '../../../../services/doctors';

@Component({
  selector: 'app-createjob',
  templateUrl: './createjob.component.html',
  styleUrl: './createjob.component.scss'
})
export class CreatejobComponent implements OnInit {

  data!: FormGroup;
  dataForm: FormData = new FormData();
  contentReady: boolean = false;
  isMobile: boolean = false;
  isAr: boolean = false;
  editId!: any;
  isUpdatePage: boolean = false;
  systemAccess: boolean = false;
  type: string = 'text';

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;

  constructor(
    private fb: FormBuilder,
    private _doctor: DoctorsService,
    private router: Router,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") === "ar";

    this.initForm();

    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.isUpdatePage = true;
        this.editId = +params['id'];

        this.data.patchValue({
          email: params['email'] || '',
          name: params['name'] || '',
          university: params['university'] || '',
          graduation_year: params['graduation_year'] || '',
          specialty: params['specialty'] || '',
          qualification: params['qualification'] || '',

          ksa_experience: params['ksa_experience'] == 1 || params['ksa_experience'] === true || params['ksa_experience'] === 'true',

          residence_place: params['residence_place'] || '',
          birth_place: params['birth_place'] || '',

          // تاريخ الميلاد
          birth_date: params['birth_date'] ? String(params['birth_date']).split('T')[0] : '',

          mobile: params['mobile'] || '',

          offer: params['offer'] == 1 || params['offer'] === true || params['offer'] === 'true',
          visa: params['visa'] == 1 || params['visa'] === true || params['visa'] === 'true',
          transfer_of_sponsorship: params['transfer_of_sponsorship'] == 1 || params['transfer_of_sponsorship'] === true || params['transfer_of_sponsorship'] === 'true',

          notes: params['notes'] || '',
        });
      }
    });

    this.contentReady = true;
  }

  initForm() {
    this.data = this.fb.group({
      name: ['', Validators.required],
      specialty: [''],
      email: ['', [Validators.email]],
      university: [''],
      graduation_year: [null, [Validators.min(1940), Validators.max(2100)]],

      ksa_experience: [false],

      residence_place: [''],
      birth_place: [''],

      // تاريخ الميلاد
      birth_date: [''],

      mobile: ['', [Validators.maxLength(30)]],
      qualification: [''],

      is_doctor: [false],

      offer: [false],
      visa: [false],
      transfer_of_sponsorship: [false],

      notes: [''],
      add_by: [localStorage.getItem("username") || 'Unknown'],
    });
  }

  appendPostDtata() {
    this.dataForm = new FormData();

    Object.entries(this.data.value).forEach(([key, value]) => {
      if (typeof value === 'boolean') {
        this.dataForm.append(key, value ? '1' : '0');
      } else if (value !== null && value !== undefined) {
        this.dataForm.append(key, value.toString());
      }
    });
  }

  onSubmit() {
    if (this.data.invalid) {
      this.data.markAllAsTouched();
      return;
    }

    this.appendPostDtata();

    if (this.isUpdatePage) {
      this.onEdit();
    } else {
      this.onAdd();
    }
  }

  onAdd() {
    this.contentReady = false;

    this._doctor.create(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم إنشاء الكادر" : 'job created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.router.navigateByUrl("/alljobs");
      },
      error: (err) => {
        this.contentReady = true;

        Swal.fire({
          icon: 'error',
          title: err?.error?.message || (this.isAr ? "فشل إنشاء الكادر" : 'job not created'),
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      }
    });
  }

  onEdit() {
    this.contentReady = false;

    const username = localStorage.getItem("username") || "Unknown";
    this.dataForm.append('editor', username);

    this._doctor.update(this.editId, this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل الكادر" : 'job updated',
          showConfirmButton: false,
          timer: 1500,
        });

        this.router.navigateByUrl("/alljobs");
      },
      error: (err) => {
        this.contentReady = true;

        Swal.fire({
          icon: 'error',
          title: err?.error?.message || (this.isAr ? "فشل تعديل الكادر" : 'job not updated'),
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      }
    });
  }
}